import {
  Badge,
  Box,
  Flex,
  Icon,
  Text,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import Image from "next/image";
import { AuditModal } from "ui";
import auditedModal from "../assets/auditedModal.svg";
import AuditedIcon from "./AuditedIcon";
import AuditedIconV1 from "./AuditedIconV1";

type AuditDataType = {
  title: string;
  link: string;
  logo: any;
};
interface SubtitleProps {
  title: string;
  tag?: string;
  description?: string;
  bugbountyLink?: string;
  logo: any;
  tagTooltip?: string;
  onClick?: (data: any) => void;
  auditData?: AuditDataType[];
  version?: 1 | 2;
}

export const Subtitle = ({
  title,
  description,
  logo,
  tag,
  tagTooltip,
  onClick,
  auditData,
  version = 2,
  bugbountyLink,
}: SubtitleProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOnclick = () => {
    onOpen();
    onClick && onClick(null);
  };

  return (
    <>
      <Flex
        mt={{ base: 0, sm: "8" }}
        px={{ base: "16px", sm: "0px" }}
        py={{ base: "12px", sm: "0px" }}
        backgroundColor={{ base: "Base_Card", sm: "transparent" }}
      >
        <Box pt={{ base: "7px", sm: "0" }}>
          <Box
            bg="brand.backgroundLight"
            borderRadius="50%"
            alignItems="center"
            mr="1rem"
            width="56px"
            height="56px"
            border="1px solid"
            borderColor="Base_Divider"
          >
            <Image src={logo} alt="" />
          </Box>
        </Box>
        <Box>
          <Flex alignItems="center" gap="0.5rem">
            <Text
              fontSize="1.5rem"
              lineHeight={{ base: "1.5rem", xl: "2rem" }}
              fontWeight="700"
            >
              {title}
            </Text>
            {tag && (
              <Badge
                px={"10px"}
                // ml={"8px"}
                height={"32px"}
                alignItems={"center"}
                display={"flex"}
                textTransform={"none"}
                borderRadius={10}
                color="Text_Main"
                backgroundColor={
                  version === 1 ? "Base_Card" : "brand.backgroundLight"
                }
                cursor={"pointer"}
                onClick={handleOnclick}
                border={{ base: "1px solid", lg: "none" }}
                borderColor="Base_Divider"
              >
                <Icon
                  as={version === 1 ? AuditedIconV1 : AuditedIcon}
                  height={14.67}
                  width={12}
                />
                {tagTooltip ? (
                  <Tooltip
                    p="15px"
                    borderRadius="8px"
                    label={tagTooltip}
                    backgroundColor={
                      version === 1 ? "Base_Divider_Inverse" : "brand.primary"
                    }
                    hasArrow
                    placement="top"
                  >
                    <Text
                      ml="10px"
                      p={0}
                      color={"Text_Main"}
                      fontWeight="400"
                      fontSize="14px"
                    >
                      {tag}
                    </Text>
                  </Tooltip>
                ) : (
                  <Text mx={1} p={0} fontSize="14px">
                    {tag}
                  </Text>
                )}
              </Badge>
            )}
            <AuditModal
              version={version}
              isOpen={isOpen}
              onClose={onClose}
              onClick={onClick && onClick}
              header="Safe &amp; Secure"
              image={{ src: auditedModal, alt: "audited" }}
              text1="Transparent & Regular Reviews."
              text2="Audited by Top Firms."
              auditData={auditData}
              bugbountyLink={bugbountyLink}
            />
          </Flex>
          <Text
            mt={{ base: "0.25rem", sm: "0.5rem" }}
            fontSize={{ base: "0.75rem", md: "0.875rem" }}
            fontWeight="400"
            textColor={version === 1 ? "Text_Sec" : "brand.disabledText"}
          >
            {description}
          </Text>
        </Box>
      </Flex>
    </>
  );
};
